module.exports = __webpack_public_path__ + "static/media/call12.cb059fd2.gif";